//                                                                                
export const NN05_EMPLOYEELIST_GET_INIT = 'NN05_EMPLOYEELIST_GET_INIT';
export const NN05_EMPLOYEELIST_GET = 'NN05_EMPLOYEELIST_GET';
export const NN05_EMPLOYEELIST_GET_SUCCESS = 'NN05_EMPLOYEELIST_GET_SUCCESS';
export const NN05_EMPLOYEELIST_GET_FAILED = 'NN05_EMPLOYEELIST_GET_FAILED';

export const NN05_RESET_FORM = 'NN05_RESET_FORM';
export const NN05_RESET_COMPONENT_STORE = 'NN05_RESET_COMPONENT_STORE';


export const NN05_SET_RESET_FORM_ENABLED = 'NN05_SET_RESET_FORM_ENABLED';
export const NN05_SET_COLUMN_HEADER_LIST = 'NN05_SET_COLUMN_HEADER_LIST';
//
export const NN05_LIST_EXPORT_TO_EXCELL = 'NN05_LIST_EXPORT_TO_EXCELL';
export const NN05_LIST_EXPORT_TO_EXCELL_FAILED = 'NN05_LIST_EXPORT_TO_EXCELL_SUCCESS';
//
//
export const SET_KEY_VALUE_PAIRS_4_NN05 = 'SET_KEY_VALUE_PAIRS_4_NN05';
// 
export const SET_CURRENT_ROW_FOCUSED = 'SET_CURRENT_ROW_FOCUSED';
// 
export const SET_SCROLL_TOP_POSITION = 'SET_SCROLL_TOP_POSITION';

export const SET_TRANS_STATE_INSERT_PERSON = 'SET_TRANS_STATE_INSERT_PERSON';
export const SET_TRANS_STATE_UPDATE_PERSON = 'SET_TRANS_STATE_UPDATE_PERSON';
export const SET_TRANS_STATE_DELETE_PERSON = 'SET_TRANS_STATE_DELETE_PERSON';

export const SET_TRANS_STATE_DIALOG_PERSON = 'SET_TRANS_STATE_DIALOG_PERSON';

export const SET_SELECTED_PERSON = 'SET_SELECTED_PERSON';
export const SET_LIST_FORMDATA = 'SET_LIST_FORMDATA';
export const SET_SUB_FORMDATA = 'SET_SUB_FORMDATA';
export const SET_ROWDATA = 'SET_ROWDATA';

export const SET_TRANS_INSERT_EMPLOYEEPOST = 'SET_TRANS_INSERT_EMPLOYEEPOST';
export const SET_TRANS_UPDATE_EMPLOYEEPOST = 'SET_TRANS_UPDATE_EMPLOYEEPOST';
export const SET_TRANS_DELETE_EMPLOYEEPOST = 'SET_TRANS_DELETE_EMPLOYEEPOST';
export const SET_TRANS_DIALOG_EMPLOYEE_FEEDBACK = 'SET_TRANS_DIALOG_EMPLOYEE_FEEDBACK';

export const NN05_EMPLOYEE_ID_GET = 'NN05_EMPLOYEE_ID_GET';
export const NN05_EMPLOYEE_ID_GET_SUCCESS = 'NN05_EMPLOYEE_ID_GET_SUCCESS';
export const NN05_EMPLOYEE_ID_GET_FAILED = 'NN05_EMPLOYEE_ID_GET_FAILED';

export const NN05_EMPLOYEE_ID_VALIDATE_GET = 'NN05_EMPLOYEE_ID_VALIDATE_GET';
export const NN05_EMPLOYEE_ID_VALIDATE_GET_SUCCESS = 'NN05_EMPLOYEE_ID_VALIDATE_GET_SUCCESS';
export const NN05_EMPLOYEE_ID_VALIDATE_GET_FAILED = 'NN05_EMPLOYEE_ID_VALIDATE_GET_FAILED';


export const NN05_LOCATION_BY_POSTALCODE_GET = 'NN05_LOCATION_BY_POSTALCODE_GET';
export const NN05_LOCATION_BY_POSTALCODE_GET_SUCCESS = 'NN05_LOCATION_BY_POSTALCODE_GET_SUCCESS';
export const NN05_LOCATION_BY_POSTALCODE_GET_FAILED = 'NN05_LOCATION_BY_POSTALCODE_GET_FAILED';


export const SET_LOCK_KEYPRESS = 'SET_LOCK_KEYPRESS';